import { render } from "./ShowPrivacyOptionsEditorCmp.vue?vue&type=template&id=229181b6"
import script from "./ShowPrivacyOptionsEditorCmp.vue?vue&type=script&lang=js"
export * from "./ShowPrivacyOptionsEditorCmp.vue?vue&type=script&lang=js"

import "./ShowPrivacyOptionsEditorCmp.vue?vue&type=style&index=0&id=229181b6&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__